/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ESidePanelContent } from '../../models';
import { ESidePanelActions, SidePanelActions } from '../actions';

import { initialSidePanelState, ISidePanelState } from '../state';

export function sidePanelReducer(state = initialSidePanelState, action: SidePanelActions): ISidePanelState {
  switch (action.type) {
    case ESidePanelActions.OpenSidePanel: {
      return {
        ...state,
        isSidePanelOpened: true,
        sidepanelContent: action.payload
      };
    }

    case ESidePanelActions.CloseSidePanel: {
      return {
        ...state,
        isSidePanelOpened: false,
        sidepanelContent: ESidePanelContent.None,
        shouldOffsetForSidePanel: false
      };
    }

    case ESidePanelActions.UpdateShouldOffsetForSidePanel: {
      return {
        ...state,
        shouldOffsetForSidePanel: action.payload
      };
    }

    default:
      return state;
  }
}
